export const PERMISSIONS = {
    ALL: "ALL",
    ADMIN: "ADMIN",
    DASHBOARD: "DASHBOARD",
    ERP_COCKPIT: "ERP_COCKPIT",
    ERP_VALIDATIONS: "ERP_VALIDATIONS",
    ERP_BUDGETS: "ERP_BUDGETS",
    ERP_NOTIFICATIONS: "ERP_NOTIFICATIONS",
    ERP_DOCUMENTS: "ERP_DOCUMENTS",
    ERP_AUDIT: "ERP_AUDIT",
    ERP_SECURITY: "ERP_SECURITY",
    ERP_BACKUPS: "ERP_BACKUPS",
    ERP_RISKS: "ERP_RISKS",
    ERP_REPORTS: "ERP_REPORTS",
    ERP_ASSISTANT: "ERP_ASSISTANT",

    FINANCE_MANAGER: "FINANCE_MANAGER",
    FINANCE_FACTURATION: "FINANCE_FACTURATION",
    FINANCE_CAISSE: "FINANCE_CAISSE",
    FINANCE_COMPTABILITE: "FINANCE_COMPTABILITE",
    FINANCE_FINANCE: "FINANCE_FINANCE",
    FINANCE_PAIE: "FINANCE_PAIE",

    APPRO_MANAGER: "APPRO_MANAGER",
    APPRO_REQUISITIONS: "APPRO_REQUISITIONS",
    APPRO_FACTURATION: "APPRO_FACTURATION",
    APPRO_MAGASIN: "APPRO_MAGASIN",
    APPRO_CARBURANT: "APPRO_CARBURANT",

    RH_MANAGER: "RH_MANAGER",
    RH_SERVICES_GENERAUX: "RH_SERVICES_GENERAUX",
    RH_BATIMENT: "RH_BATIMENT",
    RH_PERSONNEL: "RH_PERSONNEL",
    RH_BIENS: "RH_BIENS",
    RH_RECEPTION: "RH_RECEPTION",

    OPERATIONS_MANAGER: "OPERATIONS_MANAGER",
    OPERATIONS_TRANSPORT: "OPERATIONS_TRANSPORT",
    OPERATIONS_MAINTENANCE: "OPERATIONS_MAINTENANCE",
    OPERATIONS_SPS: "OPERATIONS_SPS",
    OPERATIONS_DEMANDES: "OPERATIONS_DEMANDES",
    OPERATIONS_POD_CREATE: "OPERATIONS_POD_CREATE",
    OPERATIONS_POD_LIST: "OPERATIONS_POD_LIST",

    TEAM_IT_MANAGER: "TEAM_IT_MANAGER",
    TEAM_IT_PROGRAMMATION: "TEAM_IT_PROGRAMMATION",
    TEAM_IT_RESEAU: "TEAM_IT_RESEAU",
    TEAM_IT_PROJET: "TEAM_IT_PROJET",
    TEAM_IT_DESIGN: "TEAM_IT_DESIGN",

    HSSE_MANAGER: "HSSE_MANAGER",
    HSSE_GARDES: "HSSE_GARDES",
    HSSE_ESCORTE: "HSSE_ESCORTE",

    DG_MANAGER: "DG_MANAGER",
    DG_SECRETARIAT: "DG_SECRETARIAT",
};

export const PERMISSION_GROUPS = [
    {
        key: "ADMINISTRATION",
        label: "Administration",
        permissions: [
            { code: PERMISSIONS.ADMIN, label: "Utilisateurs et roles" },
        ],
    },
    {
        key: "PILOTAGE_ERP",
        label: "Pilotage ERP",
        permissions: [
            { code: PERMISSIONS.ERP_COCKPIT, label: "Cockpit Direction Generale" },
            { code: PERMISSIONS.ERP_VALIDATIONS, label: "Centre de validation" },
            { code: PERMISSIONS.ERP_NOTIFICATIONS, label: "Notifications intelligentes" },
            { code: PERMISSIONS.ERP_DOCUMENTS, label: "Documents et archives" },
            { code: PERMISSIONS.ERP_AUDIT, label: "Audit et tracabilite" },
            { code: PERMISSIONS.ERP_SECURITY, label: "Actions sensibles" },
            { code: PERMISSIONS.ERP_BACKUPS, label: "Sauvegardes" },
            { code: PERMISSIONS.ERP_RISKS, label: "Indicateurs de risque" },
            { code: PERMISSIONS.ERP_REPORTS, label: "Rapports programmes" },
            { code: PERMISSIONS.ERP_ASSISTANT, label: "Assistant interne" },
        ],
    },
    {
        key: "DIRECTION_FINANCES",
        label: "Direction Finances",
        permissions: [
            { code: PERMISSIONS.FINANCE_MANAGER, label: "Manager Direction Finances" },
            { code: PERMISSIONS.FINANCE_FACTURATION, label: "Facturation" },
            { code: PERMISSIONS.FINANCE_CAISSE, label: "Caisse" },
            { code: PERMISSIONS.FINANCE_COMPTABILITE, label: "Comptabilite" },
            { code: PERMISSIONS.FINANCE_FINANCE, label: "Finance" },
            { code: PERMISSIONS.ERP_BUDGETS, label: "Budgets" },
            { code: PERMISSIONS.FINANCE_PAIE, label: "Paie" },
        ],
    },
    {
        key: "DIRECTION_APPROVISIONNEMENTS",
        label: "Direction Approvisionnements",
        permissions: [
            { code: PERMISSIONS.APPRO_MANAGER, label: "Manager Direction Approvisionnements" },
            { code: PERMISSIONS.APPRO_REQUISITIONS, label: "Requisitions" },
            { code: PERMISSIONS.APPRO_FACTURATION, label: "Facturation" },
            { code: PERMISSIONS.APPRO_MAGASIN, label: "Magasin" },
            { code: PERMISSIONS.APPRO_CARBURANT, label: "Carburant" },
        ],
    },
    {
        key: "RESSOURCES_HUMAINES",
        label: "RH",
        permissions: [
            { code: PERMISSIONS.RH_MANAGER, label: "Manager Ressources Humaines" },
            { code: PERMISSIONS.RH_SERVICES_GENERAUX, label: "Services Generaux" },
            { code: PERMISSIONS.RH_BATIMENT, label: "Gestion du Batiment" },
            { code: PERMISSIONS.RH_PERSONNEL, label: "Gestion du personnel" },
            { code: PERMISSIONS.RH_BIENS, label: "Gestion des biens" },
            { code: PERMISSIONS.RH_RECEPTION, label: "Reception" },
        ],
    },
    {
        key: "DIRECTION_OPERATIONS",
        label: "Direction Operations",
        permissions: [
            { code: PERMISSIONS.OPERATIONS_MANAGER, label: "Manager Direction Operations" },
            { code: PERMISSIONS.OPERATIONS_TRANSPORT, label: "Service Transport" },
            { code: PERMISSIONS.OPERATIONS_MAINTENANCE, label: "Pannes" },
            { code: PERMISSIONS.OPERATIONS_SPS, label: "SPS et Chomage" },
            { code: PERMISSIONS.OPERATIONS_DEMANDES, label: "Demandes de fonds" },
            { code: PERMISSIONS.OPERATIONS_POD_CREATE, label: "POD - Saisie" },
            { code: PERMISSIONS.OPERATIONS_POD_LIST, label: "POD - Liste et rapports" },
        ],
    },
    {
        key: "TEAM_IT",
        label: "Team IT",
        permissions: [
            { code: PERMISSIONS.TEAM_IT_MANAGER, label: "Manager Team IT" },
            { code: PERMISSIONS.TEAM_IT_PROGRAMMATION, label: "Programmation" },
            { code: PERMISSIONS.TEAM_IT_RESEAU, label: "Reseau" },
            { code: PERMISSIONS.TEAM_IT_PROJET, label: "Projet" },
            { code: PERMISSIONS.TEAM_IT_DESIGN, label: "Design" },
        ],
    },
    {
        key: "DIRECTION_HSSE",
        label: "Direction HSSE",
        permissions: [
            { code: PERMISSIONS.HSSE_MANAGER, label: "Manager Direction HSSE" },
            { code: PERMISSIONS.HSSE_GARDES, label: "Gardes" },
            { code: PERMISSIONS.HSSE_ESCORTE, label: "Escorte" },
        ],
    },
    {
        key: "DIRECTION_GENERALE",
        label: "Direction Generale",
        permissions: [
            { code: PERMISSIONS.DG_MANAGER, label: "Manager Direction Generale" },
            { code: PERMISSIONS.DG_SECRETARIAT, label: "Secretariat" },
        ],
    },
];

export const ALL_PERMISSION_CODES = [
    PERMISSIONS.DASHBOARD,
    ...PERMISSION_GROUPS.flatMap((group) => group.permissions.map((permission) => permission.code)),
];
